const validationGroup = async (validationGroupRef) => {
  const validationRes = validationGroupRef.current.instance.validate();

  let promise = new Promise((resolve, reject) => {
    if (validationRes.complete) {
      if (validationRes.isValid) validationRes.status === "pending" && validationRes.complete.then((r) => (r.status === "invalid" ? reject(false) : resolve(true)));
      else reject(false);
    } else validationRes.isValid ? resolve(true) : reject(false);
  });

  return promise.then((values) => values).catch((error) => error);
};

export default validationGroup;
